import classNames from 'classnames';
import { Icon, SvgAnimation } from '@/components/standalone';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';

function PlatformsLabelsSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const animationRef = useRef();
  const { isOnScreen: isAnimationOnScreen } = useOnScreen({
    ref: animationRef,
    threshold: 0.5,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div className={classNames('section', styles.personaeSection)}>
      <div className={classNames('max-content-width', styles.classic)}>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag">
            <Icon name="Tag" />
            LABELS
          </div>
          <h2>Boost your user experience for free</h2>
          <p>
            We extract data from audits, and provide you with beautiful and
            comprehensive labels that are easy to integrate and game-changer to
            users, thus avoiding them long and fastidious due dilligence.
          </p>
        </div>
        <div ref={animationRef} className={styles.personaeSectionAnimation}>
          <SvgAnimation
            name="Labels2"
            autoplay={isAnimationOnScreen}
            onComplete={(animation) => {
              animation.playSegments(
                [0.9 * 60, animation.getDuration() * 60],
                true,
              );
              // eslint-disable-next-line no-param-reassign
              animation.loop = true;
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PlatformsLabelsSection;
